import { ReactElement, useState } from 'react';
import { useTranslation } from 'next-i18next';
import Swiper from '~/ui/components/common/Swiper/Swiper';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';
import useReadMoreAnimation from '~/hooks/useHpReadMoreAnimation';

const ReadMoreSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$readMoreSection' });
  const { t: tLink } = useTranslation('', {
    keyPrefix: '$local.$homePageLinks.$readMoreSection',
  });

  const slides = [
    {
      id: 1,
      title: t('firstSlideTitle'),
      description: t('firstSlideDescription'),
      imageSrc: 'images/homePage/banners/hp-read-more-french-artisans.webp',
      link: tLink('firstSliderLink'),
    },
    {
      id: 2,
      title: t('secondSlideTitle'),
      description: t('secondSlideDescription'),
      imageSrc: 'images/homePage/banners/hp-read-more-aromatic.webp',
      link: tLink('secondSliderLink'),
    },
    {
      id: 3,
      title: t('thirdSlideTitle'),
      description: t('thirdSlideDescription'),
      imageSrc: 'images/homePage/banners/hp-read-more-bed.webp',
      link: tLink('thirdSliderLink'),
    },
    {
      id: 4,
      title: t('fourthSlideTitle'),
      description: t('fourthSlideDescription'),
      imageSrc: 'images/homePage/banners/hp-read-more-sofitel-mybed.webp',
      link: tLink('fourthSliderLink'),
    },
    {
      id: 5,
      title: t('fifthSlideTitle'),
      description: t('fifthSlideDescription'),
      imageSrc: 'images/homePage/banners/hp-read-more-radiance.webp',
      link: tLink('fifthSliderLink'),
    },
  ];

  const [firstImgLoaded, setFirstImgLoaded] = useState(false);
  const renderSlide = (slide: any): ReactElement => (
    <Link href={slide.link} data-event-name="bloc_interact" data-bloc-name={slide.title}>
      <picture>
        <img
          loading={firstImgLoaded ? 'eager' : 'lazy'}
          data-src={slide.imageSrc}
          alt={slide.title}
          src={slide.imageSrc}
          onLoad={() => {
            setFirstImgLoaded(true);
          }}
          width="1000"
          height="1022"
        />
      </picture>
      <div className="cta-wrapper">
        <div className="read-more-hover-content">
          <div className="title-description-wrapper">
            <h3>{slide.title}</h3>
            <p>{slide.description}</p>
          </div>
          <span className="btn base-btn btn-main">
            <span>{t('readMore')}</span>
          </span>
        </div>
      </div>
    </Link>
  );

  useReadMoreAnimation();

  return (
    <section id="hp-read-more" className="hp-section read-more">
      <h2 className="sr-only">{t('title')}</h2>
      <div className="carousel-wrapper">
        <div className="hp-swiper swiper">
          <Swiper
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            slides={slides}
            renderSlide={renderSlide}
            navigation // Include navigation
            pagination // Include pagination
            containerModifierClass="swiper-container-"
            className="swiper-container swiper-wrapper"
            // Default values - making mobile as default
            slidesPerView={1.2}
            slidesPerGroup={1} // Move 'X' slides at a time
            spaceBetween={8} // Add space between slides
            touchEventsTarget="container"
            breakpoints={{
              // when window width is >= 480px
              480: {
                slidesPerView: 1.2,
                slidesPerGroup: 1,
                spaceBetween: 14,
              },
              // when window width is >= 660px
              660: {
                slidesPerView: 2.2,
                slidesPerGroup: 2,
                spaceBetween: 20,
              },
              // when window width is >= 1440px
              1440: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 20,
              },
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default ReadMoreSection;
